var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Log_Out_Icon",
    "data-name": "Log Out Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 32,
    height: 32,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6",
    transform: "translate(1.233 1.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M34.933,19.734,29.667,14.4a1.4,1.4,0,0,0-1.8-.133,1.267,1.267,0,0,0-.133,2L30.8,19.334H15.333a1.333,1.333,0,1,0,0,2.667H30.8l-3.067,3.067a1.267,1.267,0,0,0,.133,2,1.4,1.4,0,0,0,1.8-.133L34.933,21.6a1.267,1.267,0,0,0,0-1.867Z",
    transform: "translate(-5.9 -6)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M19.283,28.667H16.617a12,12,0,0,1,0-24h2.667a1.367,1.367,0,0,0,1.333-1.333,1.6,1.6,0,0,0-.133-.6A1.333,1.333,0,0,0,19.283,2h-2.8a14.667,14.667,0,0,0,.067,29.333h2.733a1.333,1.333,0,0,0,.933-.4l.267-.333a1.6,1.6,0,0,0,.133-.6A1.333,1.333,0,0,0,19.283,28.667Z",
    transform: "translate(-1.85 -2)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M15.562,2.908a1.027,1.027,0,0,0-.1-.409.985.985,0,0,0-.877-.5H12.542C6.623,2.013,1.837,6.493,1.85,12.008s4.822,9.975,10.741,9.963h2a1.01,1.01,0,0,0,.682-.272l.195-.227a1.027,1.027,0,0,0,.1-.409C15.562,20.562,15.558,3.147,15.562,2.908Z",
    transform: "translate(3.205 6.362)",
    fill: "#2666cf",
    opacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.3c4b6fd10cd98729143d276a14ea7a16.svg";
export { ForwardRef as ReactComponent };